import Countdown from 'react-countdown'
import { Link } from 'react-router-dom'
import { useContext, useEffect } from 'react'
import dayjs from 'dayjs'
import { useTrivia } from '../../contexts/trivia-context'
import { useSession } from '../../contexts/session-context'
import { LoaderContext } from '../../contexts/loader-context'
import {
  DivTriviaList,
  DivTriviaListBorder,
  DivTitleTriviaList,
  H2TitleTriviaList,
  TriviaDescription,
  DivTriviaContainer
} from '../../theme/trivias'

const TriviaList = () => {
  const [state, { getTrivias }] = useTrivia()
  const { setLoad } = useContext(LoaderContext)
  const [{ user }] = useSession()

  useEffect(() => {
    getTrivias()
  }, [])

  if (!state.trivias) {
    setLoad(true)
  } else {
    setLoad(false)
  }

  return (
    <DivTriviaList className="md:max-w-screen-md lg:max-w-screen-lg">
      <div className="relative w-screen flex justify-start items-center px-6 py-4 md:px-0">
        <h1 className=" text-3xl font-bold">TRIVIAS</h1>
        <button
          className="din uppercase right-0 top-0 absolute h-18 hidden"
          style={{ fontSize: 8 }}
          onClick={() =>
            gtag('event', 'Click', {
              event_category: GTM_EVENT_CATEGORY,
              event_label: 'TRIVIA - Ordenar Trivias',
              value: '10'
            })
          }
        >
          ordenar por
        </button>
      </div>
      {state.trivias && state.trivias.length ? (
        <div className="grid grid-cols-1 md:gap-4 md:grid-cols-2 lg:grid-cols-3 auto-rows-fr">
          {state.trivias.filter((item) => !item?.directAccess).map((item) => {
            const hasEnoughPoints = parseInt(user?.totalPoints || '0', 10) >= item.costInPoints
            const isAvailable = item.stock !== 0
            const isUnlimited = isAvailable && item.stock === -1
            let shouldShowCountdown = false
            let isActive = hasEnoughPoints

            let dateCountdown
            let countdownType
            const nowDate = dayjs(new Date())
            if (item.validFrom) {
              const validFrom = new Date(item.validFrom as string)
              const date = dayjs(validFrom)
              if (nowDate <= date) {
                countdownType = 'Comienza en'
                shouldShowCountdown = true
                dateCountdown = date.toDate()
              }
              if (nowDate < date) isActive = false
            }

            if (item.validTo && !countdownType) {
              const validTo = new Date(item.validTo as string)
              const date = dayjs(validTo)
              if (nowDate <= date) {
                countdownType = 'Finaliza en'
                shouldShowCountdown = true
                dateCountdown = date.toDate()
              }

              if (nowDate > date) isActive = false
            }

            if (isAvailable && false as any && item.imageUrl !== '') {
              return (
                <Link
                  key={`trivia-item-${item.id}`}
                  to={`/trivia/${item.id}`}
                  className={`h-full ${isActive ? '' : 'pointer-events-none'}`}
                >
                  <DivTriviaListBorder className={`border-b h-full flex flex-col`} isActive={isActive}>
                    <DivTitleTriviaList className={` flex justify-start items-center${isActive ? '' : 'opacity-80'}`}>
                      <H2TitleTriviaList className="uppercase py-4 pl-6 pr-4 nersans text-[15px]">
                        {item.interest}
                      </H2TitleTriviaList>
                      <h2 className="uppercase py-4 pl-4 pr-6 nersans text-[20px]">{item?.name}</h2>
                    </DivTitleTriviaList>
                    <DivTriviaContainer className="pt-4 flex flex-col justify-between flex-1">
                      <TriviaDescription className="pb-2 text-center px-6">{item.description}</TriviaDescription>
                      <div className="flex items-center">
                        <img
                          src={item.imageUrl}
                          className="ml-5"
                          alt="logo"
                          style={{ width: '58px' }}
                        />
                        <h3 className="text-center uppercase text-2xl font-bold px-6 w-full nersans">{item.prize}</h3>
                        <img
                          src={item.imageUrl}
                          className="mr-5 invisible"
                          alt="logo"
                          style={{ width: '58px' }}
                        />
                      </div>

                      <div className="flex justify-between w-full items-center px-6 mt-4 py-1">
                        <div>
                          {shouldShowCountdown && (
                            <p className='raleway font-medium'>
                              {countdownType} <br /> <Countdown date={dateCountdown} />
                            </p>
                          )}
                        </div>
                        {!isUnlimited && (
                          <p className="raleway font-medium uppercase text-center text-xs">
                            {item.stock} disponible{item.stock > 1 ? 's' : ''}
                          </p>
                        )}
                        {item.costInPoints > 0 && (
                          <div className="flex justify-center items-center">
                            <span className="text-3xl uppercase nersans font-bold">{item.costInPoints}</span>
                            <span className="text-xs uppercase nersans mt-2 ml-2">{POINTS_NAME}</span>
                          </div>
                        )}
                        {item.costInPoints === 0 && (
                          <div className="flex justify-center items-center">
                            GRATIS
                          </div>
                        )}
                      </div>
                    </DivTriviaContainer>
                    {!hasEnoughPoints && (
                      <div className="uppercase raleway text-xs text-center pb-4 ">
                        no tienes las {POINTS_NAME} suficientes
                      </div>
                    )}
                  </DivTriviaListBorder>
                </Link>
              )
            } else if (isAvailable) {
              return (
                <Link
                  key={`trivia-item-${item.id}`}
                  to={`/trivia/${item.id}`}
                  className={`h-full ${isActive ? '' : 'pointer-events-none'}`}
                >
                  <DivTriviaListBorder className={`border-b h-full flex flex-col`} isActive={isActive}>
                    <DivTitleTriviaList className={` flex justify-start items-center${isActive ? '' : 'opacity-80'}`}>
                      <H2TitleTriviaList className="font-bold uppercase text-lg py-4 pl-6 pr-4">
                        {item.interest}
                      </H2TitleTriviaList>
                      <h2 className="uppercase text-sm py-4 pl-4 pr-6">{item?.name}</h2>
                    </DivTitleTriviaList>
                    <DivTriviaContainer className="pt-4 flex flex-col justify-between flex-1">
                      <p className="din pb-2 text-center px-6">
                        Contesta {item.nbrOfQuestions} preguntas sobre el tema y gana:
                      </p>
                      <h3 className="text-center uppercase text-2xl font-bold px-6 pb-2">{item.prize}</h3>
                      {!isUnlimited && (
                        <p className="din uppercase text-center text-xs">
                          {item.stock} disponible{item.stock > 1 ? 's' : ''}
                        </p>
                      )}
                      <div className="flex justify-between w-full items-center px-6 mt-4 py-1">
                        <div>
                          {shouldShowCountdown && (
                            <>
                              {countdownType} <Countdown date={dateCountdown} />
                            </>
                          )}
                        </div>
                        {item.costInPoints > 0 && (
                          <div className="flex justify-center items-center">
                            <span className="text-3xl uppercase nersans font-bold">{item.costInPoints}</span>
                            <span className="text-xs uppercase nersans mt-2 ml-2">{POINTS_NAME}</span>
                          </div>
                        )}
                        {item.costInPoints === 0 && (
                          <div className="flex justify-center items-center">
                            GRATIS
                          </div>
                        )}
                      </div>
                    </DivTriviaContainer>
                    {!hasEnoughPoints && (
                      <div className="uppercase din text-xs text-center pb-4">
                        no tienes las {POINTS_NAME} suficientes
                      </div>
                    )}
                  </DivTriviaListBorder>
                </Link>
              )
            } else {
              return null
            }
          })}
        </div>
      ) : (
        <div className="w-full h-full flex justify-center items-center">
          <p className="font-bold text-3xl text-center">NO HAY TRIVIAS DISPONIBLES</p>
        </div>
      )}
    </DivTriviaList>
  )
}

export default TriviaList
